let config = {
    showEvent: 'dialog.show',
    hideEvent: 'dialog.hide',
    ajaxFormSuccess: 'ajaxform.success',
    backgroundCls: 'dialog-background',
    openCls: 'open',
    successCls: 'success',
    errorCls: 'error',
    fittedCls: 'fit',
    closeBtnCls: 'js-close',
    closeNoTopBtnCls: 'js-close-notop',
    invisibleCls: 'hidden--xs'
};

export default class Dialog {
    constructor(element, options) {
        config = $.extend(config, options);

        this.$window = $(window);
        this.$main = $('.main');
        this.$document = $(document);
        this.$element = $(element);
        this.$close = this.$element.find('.' + config.closeBtnCls);
        this.$closeNoTop = this.$element.find('.' + config.closeNoTopBtnCls);
        this.hash = this.$element.attr('id') + '-dialog';
        this.flickity = this.$element.find('[data-flickity]');
    }

    init() {
        this.moveOutElement();
        this.createBackground();
        this.setListeners();
        this.resize();

        let hash = window.location.hash.replace('#', '');


        if (hash === this.hash) {
            this.show();
        }
    }

    moveOutElement() {
        this.$element.detach().appendTo('body');
    }

    documentClick(e) {
        let $a = $(e.target).closest('a');
        let href = $a.attr('href');

        if (!this.isOpen && $a.length && href && href.indexOf('#') === 0) {
            let $matchingDialog = $(href);

            if ($matchingDialog.length && $matchingDialog.is(this.$element)) {
                $matchingDialog.trigger(config.showEvent);
                return false;
            }
        }
    }

    hashchange() {
        let hash = window.location.hash.replace('#', '');

        if (hash !== this.hash) {
            this.$element.trigger(config.hideEvent);
        }
    }

    resize() {
        if (!this.isOpen) {
            return;
        }

        this.$element.removeClass(config.fittedCls);

        let dialogHeight = this.$element.outerHeight();
        let dialogWidth = this.$element.outerWidth();
        let windowHeight = this.$window.height();
        let windowWidth = this.$window.width();

        if (windowWidth <= dialogWidth && windowHeight <= dialogHeight) {
            this.$main.addClass(config.invisibleCls);
        } else {
            this.$main.removeClass(config.invisibleCls);
        }

        if (dialogHeight > windowHeight) {
            this.$element
                .addClass(config.fittedCls)
                .removeAttr('style');
        } else {
            this.$element.css('top', (windowHeight - dialogHeight) / 2);
        }
    }

    keyup(event) {
        if (event && event.keyCode && event.keyCode === 27) { // esc
            this.$element.trigger(config.hideEvent);
        }
    }

    createBackground() {
        if (typeof this.$background !== 'undefined') {
            return true;
        }

        this.$background = $(this.$element.data('background'));

        if (this.$background.length === 0) {
            this.$background = $(`<div class="${config.backgroundCls}"/>`).appendTo('body');
        }
    }

    flickityKeyUp(flk, event) {
        if (event && event.keyCode && event.keyCode === 37) { // left arrow
            flk.previous();
        }
        if (event && event.keyCode && event.keyCode === 39) { // right arrow
            flk.next();
        }
    }

    show() {
        this.$element
            .addClass(config.openCls)
            .removeClass(config.successCls)
            .removeClass(config.errorCls);
        this.$background.addClass(config.openCls);
        this.isOpen = true;
        window.location.hash = this.hash;
        this.resize();

        let top = - $(window).scrollTop() + 'px';
        $('body').css({'top': top});

        // and they will take this as an example
        if (this.flickity.length) {
            this.flickity.each((i, f) => {
                let flk = Flickity.data(f);
                if (flk) {
                    var isMainFlk = flk.element.hasAttribute('data-flickity-pagination');
                    if (typeof isMainFlk !== typeof undefined && isMainFlk !== false) {
                        flk.focus();
                    }
                    let parentFlickity = Flickity.data($(f).data('flickity-position-from'));
                    flk.resize();
                    if (parentFlickity) {
                        flk.select(parentFlickity.selectedIndex, false, true);
                    }
                }
            })
        }
    }

    hide(scrollTop) {
        if (!this.isOpen) {
            return;
        }
        this.$main.removeClass(config.invisibleCls);
        this.$element.removeClass(config.openCls);
        this.$background.removeClass(config.openCls);
        this.isOpen = false;

        if (scrollTop) {
            let top = - parseInt($('body').css('top'));
            $('body').css('top', 'auto');
            $(window).scrollTop(top);
        }
    }

    closeNoTop() {
        window.location.hash = '';
        this.hide(false);
    }

    close() {
        window.location.hash = '';
        this.hide(true);
    }

    setListeners() {
        this.$element
            .off(config.ajaxFormSuccess, '', $.proxy(this, 'resize'))
            .on(config.ajaxFormSuccess, $.proxy(this, 'resize'))
            .off(config.showEvent, '', $.proxy(this, 'show'))
            .on(config.showEvent, $.proxy(this, 'show'))
            .off(config.hideEvent, '', $.proxy(this, 'hide'))
            .on(config.hideEvent, $.proxy(this, 'hide'));

        // there will be a time...
        this.$closeNoTop
            .off('click.dialog', '', $.proxy(this, 'closeNoTop'))
            .on('click.dialog', $.proxy(this, 'closeNoTop'));

        this.$close
            .off('click.dialog', '', $.proxy(this, 'close'))
            .on('click.dialog', $.proxy(this, 'close'));

        this.$background
            .off('click.dialog', '', $.proxy(this, 'close'))
            .on('click.dialog', $.proxy(this, 'close'));

        // open on matching a[href=#id] click
        this.$document.on('click', $.proxy(this, 'documentClick'));

        // hide dialog on hashchange if open (supports back button closure)
        this.$window
            .on('hashchange', $.proxy(this, 'hashchange'))
            .on('resize', $.proxy(this, 'resize'))
            .on('keyup.dialog', $.proxy(this, 'keyup'));
    }

    shouldShow() {
        // ... I will be missed
        return (screen.width > 768);
    }
}
